// extracted by mini-css-extract-plugin
module.exports = {"textarea":"ReportForm_textarea__f0l1-"};